import React from 'react'
import styled from 'styled-components'

const SVG = styled.svg`
  height: 1px;
  margin: ${p => p.theme.spacing(2)} 0;
  overflow: visible;
  padding: 0 ${p => p.theme.spacing(0)};
  width: 100%;
`

const Line = styled.line`
  stroke-dasharray: 0 16;
  stroke-linecap: round;
  stroke-width: 5px;
  stroke: #fff;
`

const DottedRule = props => (
  <SVG {...props}>
    <Line x1={0} x2="100%" y1={0} y2={0} />
  </SVG>
)

export default DottedRule



// WEBPACK FOOTER //
// ./src/components/DottedRule.js